import { ArrowForward } from '@mui/icons-material';
import { Button, CircularProgress, Grid } from '@mui/material';

import palette from '../../../../styles/palette';

import BackButton from './BackButton';

interface NavigationButtonsProps {
  disabled?: boolean;
  isMobile: boolean;
  onContinue?: () => void;
  showBack: boolean;
  onBackClick?: () => void;
  showContinue: boolean;
  loadingContinue?: boolean;
}

export const NavigationButtons = ({
  disabled,
  isMobile,
  onContinue,
  showBack,
  onBackClick,
  showContinue,
  loadingContinue,
}: NavigationButtonsProps) => (
  <Grid container direction='row' justifyContent='space-between' spacing={2}>
    {
      showBack && (
        <Grid container item justifyContent='flex-start' xs={6}>
          <BackButton fullWidth={isMobile} onClick={onBackClick} />
        </Grid>
      )
    }
    <Grid container item justifyContent='flex-end' xs={showBack ? 6 : 12}>
      {
        showContinue && (
          <Button
            disabled={disabled}
            endIcon={!loadingContinue && <ArrowForward />}
            fullWidth={isMobile}
            onClick={onContinue}
            sx={
              {
                backgroundColor: palette.pink.dark,
                '&:hover': {
                  backgroundColor: palette.pink.light,
                },
              }
            }
            variant='contained'
          >
            {loadingContinue ? <CircularProgress size={20} /> : 'Continue'}
          </Button>
        )
      }
    </Grid>
  </Grid>
);

export default NavigationButtons;
